import { Globe, Sun, Moon, LogOut } from "lucide-react";
import { Logo } from "@/components/logo";
import { useServerStatus } from "@/hooks/use-server-status";
import { useTheme } from "@/hooks/use-theme";
import { logout } from "@/lib/auth";
import { toast } from "sonner";

export function TabBar() {
  const { data: status } = useServerStatus();
  const { theme, toggleTheme } = useTheme();
  const handleSignOut = () => void logout();

  const copyText = (text: string, label: string) => {
    navigator.clipboard.writeText(text).then(() => toast.success(`Copied: ${label}`));
  };

  return (
    <div className="flex items-center h-12 px-4 gap-1 bg-tab-bar border-b border-border">
      <Logo size={22} className="mr-2 shrink-0" />
      <div className="text-sm font-semibold text-foreground tracking-tight">
        Voicing
      </div>
      <span className="ml-2 text-xs text-muted-foreground">
        Telephony Control Plane
      </span>
      <div className="flex-1" />
      {status?.public_ip && (
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Globe size={13} />
          <span
            className="font-mono cursor-pointer hover:text-foreground hover:underline transition-colors"
            title="Click to copy"
            onClick={() => copyText(status.public_ip!, status.public_ip!)}
          >
            {status.public_ip}
          </span>
          {status.public_url && (
            <button
              className="font-mono text-primary/80 cursor-pointer hover:text-primary hover:underline transition-colors ml-0.5"
              title="Click to copy"
              onClick={() => copyText(status.public_url!.replace(/^sip:/, ""), status.public_url!)}
            >
              {status.public_url}
            </button>
          )}
        </div>
      )}
      <button
        onClick={toggleTheme}
        aria-label="Toggle theme"
        title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        className="ml-3 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-sm text-muted-foreground transition-colors duration-150 ease-out hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/30"
      >
        {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
      </button>
      <button
        onClick={handleSignOut}
        aria-label="Sign out"
        title="Sign out"
        className="ml-1 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-sm text-muted-foreground transition-colors duration-150 ease-out hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/30"
      >
        <LogOut size={15} />
      </button>
    </div>
  );
}
